import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {Subscription} from "rxjs";
import {AuthService} from "../../services/auth/auth.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit, OnDestroy{

  url: string;
  login: string | null = null;
  menuUserIsOpen = false;

  loginSubscription!: Subscription;

  constructor(
    public authSrv: AuthService
  ) {
    this.url = environment.wwwEndpoint;
  }

  async ngOnInit(): Promise<void> {
    this.setLogin();
    this.loginSubscription = this.authSrv.signInEvent.subscribe( (status: boolean) => {
      this.setLogin();
    });
  }

  setLogin() {
    this.login = this.authSrv.getLogin();
  }

  openMenuUser() {
    this.menuUserIsOpen = !this.menuUserIsOpen;
  }

  closeMenuUser() {
    this.menuUserIsOpen = false;
  }

  ngOnDestroy(): void {
    this.loginSubscription.unsubscribe();
  }
}
